
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 5.883v-.094H0V10.734c0 .47-.023.914.023 1.383.118 1.29 1.266 2.297 2.579 2.297h9.726c.14 0 .281 0 .422-.023 1.266-.141 2.25-1.266 2.25-2.532V5.883zM10.617 9.96l-.914.89.211 1.266a.837.837 0 01-.187.703.922.922 0 01-.68.305.77.77 0 01-.399-.094L7.5 12.47l-1.148.61a.77.77 0 01-.399.093.963.963 0 01-.68-.305.858.858 0 01-.187-.703l.21-1.266-.913-.89c-.235-.235-.328-.586-.211-.89.094-.329.375-.54.703-.587l1.266-.187.562-1.149a.85.85 0 01.774-.492.85.85 0 01.773.492l.563 1.149 1.265.187c.328.047.61.281.703.586.164.281.07.633-.164.844zM0 5.18c0-.703-.07-1.407.281-2.04.492-.89 1.266-1.382 2.297-1.406h.89v.141c0 .305-.023.61.024.914.07.61.633 1.008 1.242.961.563-.047 1.032-.563 1.032-1.148v-.868h3.468v.914a1.147 1.147 0 001.196 1.079 1.141 1.141 0 001.101-1.149v-.726-.118h.446c.375 0 .726-.023 1.101.094A2.609 2.609 0 0115 4.336v.844H0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M10.969 1.898v.703a.616.616 0 01-.586.61c-.305 0-.563-.258-.586-.586V1.17a.56.56 0 01.586-.562c.328 0 .562.258.562.586.024.234.024.469.024.703zM5.203 1.898v.704a.58.58 0 01-.586.586c-.328 0-.562-.258-.562-.586v-1.43c0-.328.258-.586.562-.586.328 0 .563.258.586.586v.726z","fill":"#fff"}})])
          )
        }
      }
    